"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Label = _interopRequireDefault(require("../Label"));
var _createStyles = require("../styles/createStyles");
var _utilities = require("../utilities");
var _capitalizeFirstWord = require("../utilities/capitalizeFirstWord");
const _excluded = ["classes", "className", "children", "color", "size", "underline"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  return {
    /* Styles applied to the root element. */
    root: {
      verticalAlign: 'baseline',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      backgroundColor: 'transparent',
      // Reset default value
      border: 0,
      margin: 0,
      // Remove the margin in Safari
      borderRadius: 0,
      padding: 0,
      // Remove the padding in Firefox
      cursor: 'pointer',
      MozAppearance: 'none',
      // Reset
      WebkitAppearance: 'none',
      // Reset
      textDecoration: 'none',
      // So we take precedent over the style of a native <a /> element.
      color: 'inherit',
      '&:focus-visible': _objectSpread({}, (0, _utilities.addFocusRingStyles)(theme, {
        has_default_rounding: true
      }))
    },
    defaultColors: {
      color: theme.busbud.colors.component.link.normal.text,
      '&:hover': {
        color: theme.busbud.colors.component.link.hover.text
      },
      '&:active': {
        color: theme.busbud.colors.component.link.active.text
      }
    },
    /* Styles applied to the root element if `underline="none"`. */
    underlineNone: {
      textDecoration: 'none'
    },
    /* Styles applied to the root element if `underline="hover"`. */
    underlineHover: {
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    /* Styles applied to the root element if `underline="always"`. */
    underlineAlways: {
      textDecoration: 'underline'
    },
    inlineBlock: {
      display: 'inline-block'
    }
  };
});
const getUnderlineClassKey = underline => {
  return `underline${(0, _capitalizeFirstWord.capitalizeFirstWord)(underline)}`;
};

/**
 * **❗️ DEPRECATED**: Use the new `Link` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/typography-link):
 *
 * ```tsx
 * import { Link } from "@busbud/horizon";
 * ```
 *
 *  [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/typography-link)
 *
 * @deprecated
 */
const Link = /*#__PURE__*/_react.default.forwardRef(function Link(props, ref) {
  const {
      classes: classesOverrides,
      className,
      children,
      color,
      size = 'md',
      underline = 'hover'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/_react.default.createElement(_Label.default, (0, _extends2.default)({
    component: "a",
    size: size,
    color: color,
    ref: ref,
    rel: props.rel || (props.target === '_blank' ? 'noopener noreferrer' : undefined),
    className: cx(classes.root, classes[getUnderlineClassKey(underline)], !color && classes.defaultColors, className, props.noWrap && classes.inlineBlock)
  }, other), children);
});
var _default = exports.default = Link;